import React, { useState, useEffect } from 'react';
import {
  Button,
  Typography,
  CircularProgress,
  Backdrop,
  DialogContentText,
  DialogContent,
  DialogTitle,
  Box,
  Dialog,
  DialogActions,
  TextField,
  TablePagination
} from '@mui/material';
import { Stack } from '@mui/system';
// import MainCard from 'ui-component/cards/MainCard';
import SubCard from 'ui-component/cards/SubCard';
import { IoMdArrowBack } from 'react-icons/io';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import FieldsTable from './FieldsTable';
import {
  GetAllRequest,
  GetNonFiPendingList,
  OpsListApi,
  ProvideApproval,
  ProvideGmApproval,
  ProvideNonFiApproval,
  ProvideReject
} from 'API/Ds Approval/api';
import { getConfigData } from 'API/Config/api';
import ReajectReason from './Components/ReajectReasonBox';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import DeleteIcon from '@mui/icons-material/Delete';

function PendingForm() {
  // const style={width:'100%',display:'flex',gap:'30px',flexDirection:'row'}

  const [data, setData] = useState(null);
  const [value, setValue] = React.useState(null);
  const [Selected, setSelected] = React.useState(null);
  const [configData, setConfigData] = useState(null);
  const [selectedProducts, setSelectedProducts] = React.useState(null);
  // const [PostData, setPostData] = React.useState(null);
  const [RejectReason, setRejectReason] = useState(null);
  const userType = sessionStorage.getItem('UserType');
  const [open, setOpen] = React.useState(false);
  const [AlertOpen, setAlertOpen] = useState(false);
  const [AlertMessage, setAlertMessage] = useState(null);
  const [AlertType, setAlertType] = useState('success');
  const [disableButtons, setDisableButtons] = useState(false);
  const [Isloading, setIsloading] = useState(false);
  const [Status, setStatus] = useState(null);
  const [DialogOpen, setDialogOpen] = useState(false);
  const [Remark, setRemark] = useState('');
  const [StatusData, setStatusData] = useState('');
  const [RemarkOpen, setRemarkOpen] = React.useState(false);
  const [TotalCount, setTotalCount] = useState('');
  const [Page, setPage] = useState(1);

  const handleAlertOpen = () => {
    setAlertOpen(true);
  };

  const handleAlertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertOpen(false);
  };

  const handleClickOpen = (status) => {
    setOpen(true);
    setStatus(status);
  };

  const handleRejectClose = () => {
    setOpen(false);
  };
  // const [open, setOpen] = React.useState(false);
  // const[alertType,setAlertType]=useState('success')

  // const handleClick = () => {
  //     setOpen(true);
  // };

  // const handleAlertClose = (event, reason) => {
  //     if (reason === 'clickaway') {
  //         return;
  //     }

  //     setOpen(false);
  // };

  const smStyles = {
    width: '100%',
    display: 'flex',
    gap: '30px',
    flexDirection: 'column'
  };

  const mdLgXlStyles = {
    width: '100%',
    display: 'flex',
    gap: '30px',
    flexDirection: 'row'
  };

  const handleSelect = () => {
    setSelected(value);
    setDialogOpen(false);
  };

  const handleItemClick = (index) => {
    if (data) {
      setDialogOpen(true);
      setValue(data[index]);
      setSelectedProducts(data[index]);
    }
  };




  const [rows, setRows] = React.useState([]);

  useEffect(() => {
    if (userType === 'gm') {
      GetAllRequest(Page, setData, setIsloading, setTotalCount);
    } else if (userType === 'prod_own') {
      GetNonFiPendingList(Page, setData, setIsloading, setTotalCount);
    } else if (userType === 'non_fi_head') {
      GetNonFiPendingList(Page, setData, setIsloading, setTotalCount);
    } else {
      OpsListApi(Page, setData, setIsloading, setTotalCount);
    }
    getConfigData(setConfigData);
  }, []);

  const handlePageChange = (event, page) => {
    setPage(page);
    GetAllRequest(page, setData, setIsloading, setTotalCount);
  };

  const handleClose = () => {
    // setSelected(null)
    setAlertOpen(false);
    setRows([]);
    setSelectedProducts(null);
    setSelected(null);
    setValue(null);
  };
  const handleSubmit = () => {
    if (Remark == '') {
      alert('remark is mandatory');
    } else {
      ProvideApproval(
        selectedProducts.user_id,
        StatusData,
        setData,
        handleClose,
        setAlertMessage,
        handleAlertOpen,
        setAlertType,
        setDisableButtons,
        handleSelectedClose,
        setIsloading,
        handleRejectClose,
        setDialogOpen,
        setRemarkOpen
      );
    }
  };
  const handleSelectedClose = () => {
    if (userType === 'gm') {
      GetAllRequest(Page, setData, setIsloading, setTotalCount);
    } else if (userType === 'prod_own') {
      GetNonFiPendingList(Page, setData, setIsloading, setTotalCount);
    } else if (userType === 'non_fi_head') {
      GetNonFiPendingList(Page, setData, setIsloading, setTotalCount);
    } else {
      OpsListApi(Page, setData, setIsloading, setTotalCount);
    }
    setSelected(null);
    setDialogOpen(false);
  };

  const handleApprove = (data) => {
    if (userType === 'gm' && selectedProducts) {
      handleClickOpen(data);
    } else if ((userType === 'ops' || userType === 'rm' || userType === 'sh' || userType === 'cso') && selectedProducts) {
      setRemarkOpen(true);
      setStatusData(data);
      // ProvideApproval(
      //   selectedProducts.user_id,
      //   data,
      //   setData,
      //   handleClose,
      //   setAlertMessage,
      //   handleAlertOpen,
      //   setAlertType,
      //   setDisableButtons,
      //   handleSelectedClose,
      //   setIsloading,
      //   handleRejectClose
      // );
    } else if (userType === 'prod_own' || userType === 'non_fi_head') {
      handleClickOpen(data);
    } else {
      setAlertType('error');
      setAlertMessage('Please try again');
      handleAlertOpen();
      // setTimeout(() => {
      //   handleClose();
      // }, 1500);
    }
  };

  const handleGmApprove = () => {
    let postdata = {
      gm_remarks: RejectReason,
      user_id: selectedProducts.user_id,
      ds_gm_status: Status
    };

    ProvideGmApproval(
      postdata,
      setData,
      handleClose,
      setAlertMessage,
      handleAlertOpen,
      setAlertType,
      setDisableButtons,
      handleSelectedClose,
      setIsloading,
      handleRejectClose
    );
  };

  const handleProdOwnerApprove = () => {
    let postdata = {
      prod_own_remarks: RejectReason,
      user_id: selectedProducts.user_id,
      prod_own_ds_status: Status
    };

    ProvideNonFiApproval(
      postdata,
      setData,
      handleClose,
      setAlertMessage,
      handleAlertOpen,
      setAlertType,
      setDisableButtons,
      handleSelectedClose,
      setIsloading,
      handleRejectClose
    );
  };

  const handleNonFiHeadApprove = () => {
    let postdata = {
      prod_own_remarks: RejectReason,
      user_id: selectedProducts.user_id,
      non_fi_head_ds_status: Status
    };

    ProvideNonFiApproval(
      postdata,
      setData,
      handleClose,
      setAlertMessage,
      handleAlertOpen,
      setAlertType,
      setDisableButtons,
      handleSelectedClose,
      setIsloading,
      handleRejectClose
    );
  };

  // const handleRejectOpen = (status) => {
  //   handleClickOpen(status);
  // };

  const handleReject = () => {
    if (userType === 'ops' && RejectReason) {
      // setPostData({
      //             "product_id": value.product_id,
      //             "status": "rejected",
      //             "user_id": value.user_id,
      //             "rejected_reason":RejectReason
      //         })
      ProvideReject(
        selectedProducts.user_id,
        setData,
        handleClose,
        setAlertMessage,
        handleAlertOpen,
        setAlertType,
        setDisableButtons,
        handleSelectedClose,
        setIsloading,
        handleRejectClose
      );
    }
  };

  return (
    <>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={Isloading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <React.Fragment>
        <Dialog open={RemarkOpen} maxWidth="sm" fullWidth>
          <DialogTitle variant="h4">Remark</DialogTitle>
          <Box sx={{ position: 'absolute', top: 5, right: 5, fontSize: '25px', cursor: 'pointer' }} onClick={() => setRemarkOpen(false)}>
            <CloseIcon />
          </Box>
          <DialogContent>
            <DialogContentText sx={{ color: '#121926' }}>
              {/* Deboarding Decision Feedback and Remarks. Please review the guidelines. */}
            </DialogContentText>
            <TextField
              autoFocus
              required
              margin="dense"
              name="Remark"
              value={Remark}
              onChange={(e) => setRemark(e.target.value)}
              fullWidth
              multiline
              rows={4}
            />
          </DialogContent>
          <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
            <LoadingButton loading={Isloading} type="submit" variant="contained" onClick={handleSubmit}>
              submit
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </React.Fragment>
      {Selected ? (
        <div style={{ height: '60vh', display: 'flex', justifyContent: 'space-between', flexDirection: 'column', overflowY: 'scroll' }}>
          <Snackbar open={AlertOpen} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={3000} onClose={handleClose}>
            <Alert onClose={handleAlertClose} severity={AlertType} variant="filled" sx={{ width: '100%' }}>
              {AlertMessage}
            </Alert>
          </Snackbar>
          <ReajectReason
            status={Status}
            open={open}
            handleClose={handleRejectClose}
            setRejectReason={setRejectReason}
            handleReject={handleReject}
            handleGmApprove={handleGmApprove}
            handleProdOwnerApprove={handleProdOwnerApprove}
            handleNonFiHeadApprove={handleNonFiHeadApprove}
          />
          <div>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Button sx={{ width: '20px' }} onClick={handleSelectedClose}>
                <IoMdArrowBack style={{ color: 'black', fontSize: '20px' }} />
              </Button>
              <Typography variant="subtitle1" color="grey">
                {Selected.title}
              </Typography>
            </Stack>
            <TableContainer component={Paper}>
              <FieldsTable userType={userType} configData={configData} rows={rows} selectedItem={Selected} />
            </TableContainer>
          </div>
          <Stack direction="row" width="100%" justifyContent="space-between" spacing={1}>
            {userType === 'sh' || userType === 'rm' || userType === 'prod_own' || userType === 'non_fi_head' ? (
              ''
            ) : (
              <Button
                color="error"
                fullWidth
                sx={{ width: '20%' }}
                variant="contained"
                startIcon={<DeleteIcon />}
                disabled={disableButtons}
                onClick={() => handleApprove('Rejected')}
              >
                Reject
              </Button>
            )}
            <Button
              color="success"
              fullWidth
              sx={{ width: '20%' }}
              variant="contained"
              disabled={disableButtons}
              onClick={() => handleApprove('Approved')}
            >
              Approve
            </Button>
          </Stack>
        </div>
      ) : data && data.length > 0 ? (
        <div style={window.innerWidth >= 600 ? mdLgXlStyles : smStyles}>
          <div style={{ height: window.innerWidth >= 600 ? '70vh' : '30vh', overflowY: 'scroll', width: '100%', scrollbarWidth: 'none' }}>
            <Stack spacing={2} sx={{ width: '50%', height: '70rem' }}>
              {data &&
                data.map((item, index) => {
                  return userType === 'ops' ||
                    userType === 'sh' ||
                    userType === 'rm' ||
                    userType === 'cso' ||
                    userType === 'gm' ||
                    userType === 'prod_own' ||
                    userType === 'non_fi_head' ? (
                    <SubCard
                      title={`Onboarding for ${item.distributor_name}`}
                      key={index}
                      sx={{ cursor: 'pointer' }}
                      onClick={() => handleItemClick(index)}
                    >
                      <Stack direction="column">
                        <div></div>
                        <Stack direction="column">
                          <Typography variant="subtitle1" color="grey">
                            Date: {item.ds_add_date || item.date}
                          </Typography>
                          <Typography variant="subtitle1" color="grey">
                            {' '}
                            Time: {item.ds_add_time || item.time}
                          </Typography>
                        </Stack>
                      </Stack>
                    </SubCard>
                  ) : null;
                })}

              {data && data.length ? (
                <Stack spacing={2} justifyContent="flex-end" alignItems="flex-end" sx={{ mt: 2 }}>
                  <TablePagination
                    component="div"
                    count={TotalCount.total_count}
                    page={Page - 1}
                    rowsPerPage={TotalCount.limit}
                    onPageChange={handlePageChange}
                    rowsPerPageOptions={[10]}
                  />
                </Stack>
              ) : null}
            </Stack>
          </div>
          {/* <Stack sx={{ width: '100%', display: 'flex', visibility: value ? 'visible' : 'hidden' }}>
        <MainCard sx={{ width: '100%', backgroundColor: 'whitesmoke' }}>
          <SubCard title={value ? value.distributor_name : ''}> */}
          <Dialog
            open={DialogOpen}
            fullWidth
            maxWidth="sm"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle variant="h4" fontWeight={'700'}>
              Onboarding for {value ? value.distributor_name : ''}
            </DialogTitle>
            <DialogContent>
              <Box
                sx={{ position: 'absolute', top: 5, right: 8, fontSize: '25px', cursor: 'pointer' }}
                onClick={() => setDialogOpen(false)}
              >
                <CloseIcon />
              </Box>
              <DialogContentText id="alert-dialog-description">
                {/* <Stack direction="column">
              <div></div>
              <Stack direction="column" spacing={1}>
                <Typography variant="h5">{value ? `Date: ${value.ds_add_date || value.date}` : null}</Typography>
                <Typography variant="h5">{value ? `Time: ${value.ds_add_time || value.time}` : ''}</Typography>
                <Button variant="contained" size='small' sx={{ backgroundColor: '#A556B2' }} onClick={handleSelect}>
                  View Request
                </Button>
              </Stack>
            </Stack> */}
                <Stack sx={{ width: '100%', display: 'flex' }}>
                  <Stack direction="column" justifyContent="center" alignItems="center">
                    <table style={{ width: '100%' }}>
                      <tbody>
                        {userType === 'ops' && (
                          <tr>
                            <td>
                              <Typography variant="subtitle1">Request</Typography>
                            </td>
                            <td>:</td>
                            <td>
                              <Typography variant="subtitle1">Onboarding</Typography>
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td>
                            <Typography variant="subtitle1">Date</Typography>
                          </td>
                          <td>:</td>
                          <td>
                            <Typography variant="subtitle1">{(value && value.ds_add_date) || (value && value.date)}</Typography>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Typography variant="subtitle1">Time</Typography>
                          </td>
                          <td>:</td>
                          <td>
                            <Typography variant="subtitle1">{(value && value.ds_add_time) || (value && value.time)}</Typography>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={handleSelect}>
                      View Request
                    </Button>
                  </Stack>
                </Stack>
              </DialogContentText>
            </DialogContent>
          </Dialog>
          {/* </SubCard>
        </MainCard>
      </Stack> */}
        </div>
      ) : (
        <Stack justifyContent="center" alignItems="center">
          <Typography mt={1} variant="subtitle1" color="grey">
            No distributor onboarding request available
          </Typography>
        </Stack>
      )}
    </>
  );
}

export default PendingForm;
